import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { useGetPropertyManagers } from '../../hooks/use-get-property-managers';
import { useStatsFiltersContext } from '../../hooks/use-stats-filters';

const StatsPropertyManagerSelectionDropDown = () => {
  const { selectedPropertyManager, setSelectedPropertyManager } = useStatsFiltersContext();
  const { t } = useTranslation();

  const { data: managersData } = useGetPropertyManagers();

  return (
    <DropDown
      placeholder={t('js.features.admin.stats.dashboard.property_manager_selection.placeholder')}
      className="z-50 w-[200px]"
      showLabel
      label={t('js.features.admin.stats.dashboard.property_manager_selection.label')}
      value={selectedPropertyManager}
      onChange={setSelectedPropertyManager}
      {...(selectedPropertyManager && {
        displayValue: `${selectedPropertyManager.first_name} ${selectedPropertyManager.last_name}`,
      })}
    >
      <DropDown.DropDownOptions>
        <DropDown.DropDownOption key="all" value={undefined}></DropDown.DropDownOption>
        {managersData?.data?.map((manager) => (
          <DropDown.DropDownOption key={manager.id} value={manager}>
            <DropDown.DropDownOptionDefaultContent className="font-['sofia-pro'] text-sm font-normal leading-[21px] text-[#212529]">
              {`${manager.first_name} ${manager.last_name}`}
            </DropDown.DropDownOptionDefaultContent>
          </DropDown.DropDownOption>
        ))}
      </DropDown.DropDownOptions>
    </DropDown>
  );
};

export { StatsPropertyManagerSelectionDropDown };
